import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { connectEpic, disconnectEpic } from './_epics/connect.epic';
import { subscribeClientDiffEpic, subscribeLpDiffEpic } from './_epics/subscribeDiff.epic';
import { loadServerSymbolsEpic } from './_epics/loadServerSymbols.epic';
import { loadLpSymbolsEpic } from './_epics/loadLpSymbols.epic';

export const symbolQuotesEpic = safeCombineEpics(
  connectEpic,
  disconnectEpic,
  subscribeClientDiffEpic,
  subscribeLpDiffEpic,
  loadServerSymbolsEpic,
  loadLpSymbolsEpic,
);
